import React from 'react';

/*Get JSX Element To Print a list*/
const GetJSXList = (props) => {

    const { values } = props;

    let liItems = "";
    if (values !== undefined && values.length!== 0 && values[0]!== "")
    {
        liItems = values.map(item => { return <li key={item}>{item}</li>});
        return liItems;
    }
    else{
        return "None."
    }
}


export default GetJSXList;